import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "../components/Table/Table.css";
import { Modal } from "@mui/material";

const SendFeedback = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div className="px-2 px-md-4">
                <div className="my-4 col-12 d-flex justify-content-between align-items-center">
                    <h5 className="">{t("Send Feedback")}</h5>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Academic year")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="academic_year"
                            className="common-input form-select"
                            required
                        >
                            <option value="">Select session</option>
                            <option value="2022-2024">2022-2024</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Class Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="class"
                            className="common-input form-select"
                        >
                            <option value="">Select class</option>
                            <option value="12">12</option>
                            <option value="11">11</option>
                            <option value="10">10</option>
                            <option value="09">09</option>
                            <option value="08">08</option>
                            <option value="07">07</option>
                            <option value="06">06</option>
                            <option value="05">05</option>
                            <option value="04">04</option>
                            <option value="03">03</option>
                            <option value="02">02</option>
                            <option value="01">01</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Section Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="section"
                            className="common-input form-select"
                        >
                            <option value="">Select section</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="C">C</option>
                        </select>
                    </div>
                    <div className="col-md-4 mt-3">
                        <label className="form-label">
                            {t("Admission Number")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="admission_number"
                            className="common-input form-select"
                            required
                        >
                            <option value="">Select Admission Number</option>
                            <option value="0001/2024">Harshit [0001/2024]</option>
                            <option value="0002/2024">Deepika [0002/2024]</option>
                        </select>
                    </div>
                    <div className="col-md-4 mt-3">
                        <label className="form-label">
                            {t("Roll Number")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="roll_number"
                            className="common-input form-select"
                            required
                        >
                            <option value="">Select Roll Number</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                        </select>
                    </div>
                </div>

                <div className="row col-6 mt-5 d-flex mx-1">
                    <button
                        type="button"
                        id="btn"
                        className="btn me-2 col-md-2"
                        onClick={handleClickOpen}
                    >
                        {t("Search")}
                    </button>

                    <button
                        type="button"
                        className="btn btn-secondary me-2 col-md-2"
                    >
                        {t("Cancel")}
                    </button>
                </div>

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 500,
                            backgroundColor: "#ffffff",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: 8,
                            padding: 20,
                        }}
                    >
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handleClose}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "none",
                                border: "none",
                                fontSize: 24,
                                cursor: "pointer",
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                fill="currentColor"
                                className="bi bi-x"
                                viewBox="0 0 16 16"
                            >
                                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </button>
                        <div className="row mt-4 mb-2">
                            <div className="col-12">
                                <label className="form-label">
                                    {t("Student Name")}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    readOnly
                                />
                            </div>
                            <div className="col-12 mt-3">
                                <label className="form-label">
                                    {t("Feedback")}
                                    <span style={{ color: "red" }}>*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                ></textarea>
                            </div>
                        </div>
                        <div className="mt-4 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                            >
                                {t("Submit")}
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
}

export default SendFeedback;
